import { ProviderServiceCodesResItemType, UserServiceCode } from 'src/types/user';

const toFlagNumber = (value: number | string | boolean | null | undefined): number => {
    if (value === true || value === 1 || value === '1') {
        return 1;
    }
    return 0;
};

export const formatServiceCodes = (
    serviceCodes: ProviderServiceCodesResItemType[] | undefined | null
): UserServiceCode[] => {
    return (serviceCodes ?? []).map((serviceCode) => ({
        SHIPPER_CODE: serviceCode.SHIPPER_CODE,
        VALUE: serviceCode.VALUE,
        LABEL: serviceCode.LABEL,
        IS_EXPEDITION: toFlagNumber(serviceCode.IS_EXPEDITION),
        IS_RETURN: toFlagNumber(serviceCode.IS_RETURN),
        IS_PARCEL: toFlagNumber(serviceCode.IS_PARCEL),
        IS_PALLET: toFlagNumber(serviceCode.IS_PALLET),
        countries: (serviceCode.COUNTRY_SERVICE_CODES ?? []).map((country) => country.COUNTRY_CODE),
    }));
};
